import { BaseController } from '~client/controller/base-controller';
import { CountryResponse } from '~client/model/country-response';

/* Public APIs to retrieve Geographic Location information */
export class LocationController extends BaseController {
  /* Allows retrieval of basic country location profile data */
  public getCountryList(): Promise<CountryResponse[]> {
    return this.get('/geoData/public/countries');
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/location-controller.ts